export default "__VITE_ASSET__10eb1316__"